import { render, staticRenderFns } from "./SignWaiver.vue?vue&type=template&id=159ec511&scoped=true&"
import script from "./SignWaiver.vue?vue&type=script&lang=js&"
export * from "./SignWaiver.vue?vue&type=script&lang=js&"
import style0 from "./SignWaiver.vue?vue&type=style&index=0&id=159ec511&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ec511",
  null
  
)

export default component.exports